import type { AdminSession, AdminUser } from "@/lib/admin-api-types";
import { ADMIN_COOKIE_SESSION_MARKER } from "@/lib/admin-cookie";

const TOKEN_KEY = "admin_token";
const USER_KEY = "admin_user";

const USE_MOCK = process.env.NEXT_PUBLIC_USE_MOCK_API === "true";

export function getAdminSession(): AdminSession | null {
  if (typeof window === "undefined") return null;
  const userRaw = sessionStorage.getItem(USER_KEY);
  if (!userRaw) return null;
  try {
    const user = JSON.parse(userRaw) as AdminUser;
    if (USE_MOCK) {
      const token = sessionStorage.getItem(TOKEN_KEY);
      if (!token) return null;
      return { token, user, mfaRequired: false };
    }
    return { token: ADMIN_COOKIE_SESSION_MARKER, user, mfaRequired: false };
  } catch {
    return null;
  }
}

export function setAdminSession(session: {
  token: string;
  user: AdminUser;
}): void {
  sessionStorage.setItem(USER_KEY, JSON.stringify(session.user));
  if (USE_MOCK) {
    sessionStorage.setItem(TOKEN_KEY, session.token);
  } else {
    sessionStorage.removeItem(TOKEN_KEY);
  }
}

export function clearAdminSession(): void {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
}
